<template>
  <div :id="canvasId" class="collarCanvas">
    <div class="collar-title">{{collar}}</div>
  </div>
</template>

<script>
import * as SVG from 'svg.js/dist/svg';
import { COLLARS } from '@/common/constants';
import hoodie from '@/assets/collars/hoodie.svg';

export default {
  name: 'hoodie',
  data () {
    return {
      COLLARS,
      id: '',
      svgId: COLLARS.HOODIE,
      canvasId: 'hoodie-canvas',
      canvas: null,
      svgFile: hoodie,
      width: `${80}%`,
      height: `${70}%`,
    };
  },

  props: {
    collar: String,
  },

  mounted () {
    this.initCanvas();
    this.loadCollar();
  },

  watch: {
    insideCollarColor () {
      this.loadCollar();
    },
  },

  computed: {
    insideCollarColor () {
      return this.$store.getters['design/getInsideCollarColor'];
    },

    collarColors () {
      return [
        {
          id: '#body',
          color: this.$store.getters['design/getBodyColor']
        },
        {
          id: '#insideCollar',
          color: this.$store.getters['design/getInsideCollarColor']
        },
      ];
    },
  },

  methods: {
    initCanvas () {
      this.canvas = SVG(this.canvasId).size(this.width, this.height);
      this.id = this.canvas.node.id;
    },

    loadSvg (svgFile) {
      return fetch(svgFile).then((response) => response.text());
    },

    loadCollar () {
      const lastCollar = this.canvas.select(`#${this.svgId}`).last();
      if (lastCollar) {
        lastCollar.remove();
      }
      this.loadSvg(this.svgFile).then((svgText) => {
        this.canvas.svg(svgText);
        this.canvas.select('svg')
          .width(`${100}%`)
          .height(`${100}%`)
          .id(this.svgId)
          .cx(this.canvas.cx())
          .cy(this.canvas.cy());
        this.collarColors.forEach((element) => {
          this.canvas.select(element.id).fill(element.color.hex);
        });
      });
    },
  }
};
</script>

<style scoped>
.collarCanvas {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
}

.collar-title {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 500;
}
</style>
